import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

function FinanceMenu({ marketerID, isGetGift, openItem, activeItem, role }) {
  return (
    <>
      <li
        className={`nav-item has-treeview 
            ${sidebarHelper.checkOpenItem(openItem, "all-finance")} `}
      >
        <a
          href="# "
          className={`nav-link  
            ${sidebarHelper.checkActiveItem(openItem, "all-finance")} `}
        >
          <i className="nav-icon hl-money align-middle"></i>
          <p>
            مالی
            <i className="right fa fa-angle-left"></i>
          </p>
        </a>

        <ul className="nav nav-treeview">
          <li className="nav-item">
            <Link
              to="/finance/charge"
              className={`nav-link  
                ${sidebarHelper.checkActiveItem(
                  activeItem,
                  "charge-finance"
                )} `}
            >
              <i className="hl-monies nav-icon"></i>
              <p>افزایش اعتبار</p>
            </Link>
          </li>

          {marketerID && !isGetGift && (
            <li className="nav-item">
              <Link
                to="/finance/get-gift"
                className={`nav-link  
                ${sidebarHelper.checkActiveItem(activeItem, "get-gift")} `}
              >
                <i class="fa fa-gift nav-icon"></i>
                <p>دریافت هدیه ویژه</p>
              </Link>
            </li>
          )}

          {role === "همکار" ? (
            <></>
          ) : (
            <li className="nav-item">
              <Link
                to="/finance/pledge"
                className={`nav-link  
                ${sidebarHelper.checkActiveItem(activeItem, "all-pledge")} `}
              >
                <i class="hl-money-down-arrows nav-icon"></i>
                <p>لیست بیعانه</p>
              </Link>
            </li>
          )}

          <li className="nav-item">
            <Link
              to="/finance/invoices"
              className={`nav-link  
                ${sidebarHelper.checkActiveItem(
                  activeItem,
                  "invoices-finance"
                )} `}
            >
              <i className="hl-list-dollar nav-icon"></i>
              <p>فاکتورها و پیش فاکتورها</p>
            </Link>
          </li>
        </ul>
      </li>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    marketerID: state.main.marketer_id,
    isGetGift: state.main.is_get_gift,
  };
};

const mapDispatchToProps = () => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(FinanceMenu);
